/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_USER_PREFERENCES_OPTIONS_LIST = 'SET_USER_PREFERENCES_OPTIONS_LIST';
export const SET_USER_PREFERENCES_SELECTED_OPTION = 'SET_USER_PREFERENCES_SELECTED_OPTION';
